<template>
    <div
        :class="
            `formulate-input-element password-field formulate-input-element--${context.type}`
        "
        :data-type="context.type"
    >
        <input
            :type="showPassword ? 'text' : 'password'"
            v-model="context.model"
            v-bind="context.attributes"
            autocomplete="no"
            @blur="context.blurHandler"
        />
        <button
            type="button"
            @click="showPassword = !showPassword"
            class="icon-button"
        >
            <SvgIcon v-show="!showPassword" classes="h-6 w-6" icon="eye" />
            <SvgIcon v-show="showPassword" classes="h-6 w-6" icon="eye-off" />
        </button>
    </div>
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "ToggablePassword",
    components: { SvgIcon },
    props: {
        context: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showPassword: false
        };
    }
};
</script>
